"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFela = require("react-fela");

var _reactSelect = _interopRequireDefault(require("react-select"));

var _view = require("../view");

var _text = require("../text");

var _spacer = require("../spacer");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Select = function Select(_ref) {
  var extend = _ref.extend,
      props = _objectWithoutProperties(_ref, ["extend"]);

  var _useFela = (0, _reactFela.useFela)(),
      _useFela$theme = _useFela.theme,
      colors = _useFela$theme.colors,
      radius = _useFela$theme.radius,
      shadows = _useFela$theme.shadows,
      grid = _useFela$theme.grid;

  var customStyles = {
    container: function container(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        fontFamily: 'Roboto, sans-serif',
        fontSize: 14
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        overflow: 'hidden',
        boxShadow: shadows.big,
        marginTop: 0,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2
      });
    },
    control: function control(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        paddingLeft: 2 * grid
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_view.View, {
    extend: extend
  }, /*#__PURE__*/_react["default"].createElement(_text.Text, {
    extend: {
      paddingLeft: grid
    }
  }, props.label), /*#__PURE__*/_react["default"].createElement(_spacer.Spacer, null), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], _extends({
    styles: customStyles
  }, props, {
    theme: function theme(_theme) {
      return _objectSpread(_objectSpread({}, _theme), {}, {
        borderRadius: radius,
        colors: _objectSpread(_objectSpread({}, _theme.colors), {}, {
          neutral10: 'hotpink',
          primary25: colors.border,
          primary50: colors.border,
          primary: colors.primary
        })
      });
    }
  })));
};

exports.Select = Select;